import { getFriendBuyAPI } from '../referral';

export interface referralCustomer {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  isNewCustomer?: boolean;
}

const trackCustomer = (customer: referralCustomer): void => {
  getFriendBuyAPI().push(['track', 'customer', customer]);
};

export default trackCustomer;
